import { render, staticRenderFns } from "./infraction-rules-grid.vue?vue&type=template&id=548e1039&"
import script from "./infraction-rules-grid.vue?vue&type=script&lang=ts&"
export * from "./infraction-rules-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports